import React from 'react';
import Link from 'next/link';

const steps = [
  { num: '01', title: 'Escolha os seus serviços', desc: 'Selecione um ou vários tratamentos. O sistema calcula automaticamente o preço e a duração total.' },
  { num: '02', title: 'Escolha a data', desc: 'Veja o calendário com os dias disponíveis e escolha o que melhor se adapta à sua agenda.' },
  { num: '03', title: 'Escolha o horário', desc: 'Apenas os horários realmente disponíveis são apresentados, com base na duração dos seus serviços.' },
  { num: '04', title: 'Confirme a marcação', desc: 'Preencha os seus dados, reveja o resumo e confirme. A sua sessão fica imediatamente reservada.' },
  { num: '05', title: 'Venha desfrutar', desc: 'Apareça no dia e hora marcados e deixe-nos cuidar de si com toda a atenção que merece.' },
];

export default function HowItWorksSection() {
  return (
    <section id="cuidados" className="py-24 lg:py-32" style={{ background: '#FFC2D4' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          {/* Header */}
          <div className="lg:sticky lg:top-32">
            <span className="gold-line mb-6 block" />
            <p className="text-xs tracking-[0.25em] uppercase font-medium text-burnt-rose mb-4">
              Como Funciona
            </p>
            <h2 className="font-serif text-4xl lg:text-5xl font-light leading-[1.1] text-dark-brown mb-8">
              A sua sessão,<br />
              <em className="italic text-burnt-rose">em cinco passos simples.</em>
            </h2>
            <p className="text-base text-foreground/60 leading-relaxed mb-10">
              Marcar a sua sessão na Mãos Mágicas é rápido, simples e pode ser feito a qualquer hora — mesmo às 23h.
            </p>
            <Link
              href="/agendar"
              className="inline-flex items-center justify-center px-8 py-4 btn-primary rounded-full text-sm tracking-[0.12em] uppercase font-semibold"
            >
              Agendar Agora
            </Link>
          </div>

          {/* Steps — horizontal cards, not vertical timeline */}
          <div className="space-y-4">
            {steps?.map((step, i) => (
              <div
                key={step?.num}
                className="flex gap-5 p-5 rounded-xl border border-border hover:border-burnt-rose/30 transition-all duration-300 group"
                style={{ background: '#FFD6E0' }}
              >
                <div className="flex-shrink-0">
                  <span className="font-serif text-3xl font-light text-burnt-rose/30 group-hover:text-burnt-rose/60 transition-colors duration-300 leading-none">
                    {step?.num}
                  </span>
                </div>
                <div>
                  <h3 className="font-semibold text-sm text-dark-brown mb-1.5">{step?.title}</h3>
                  <p className="text-sm text-foreground/60 leading-relaxed">{step?.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
